import { ru } from 'date-fns/locale'
import getDateItemsFromSlots from './getDateItemsFromSlots'

describe('getDateItemsFromSlots', () => {
  afterEach(() => {
    jest.useRealTimers()
  })

  describe('Когда у дня есть слоты', () => {
    test('Тогда день активен и содержит дату с подписью дня недели', () => {
      jest.useFakeTimers().setSystemTime(new Date('2026-03-10T12:00:00Z'))

      const items = getDateItemsFromSlots({
        '2026-03-04': [{ time: '16:00' }],
      }, ru)

      expect(items).toEqual([{
        date: '2026-03-04',
        title: '4 мар',
        subtitle: 'Ср',
        label: '',
        disabled: false,
      }])
    })
  })

  describe('Когда подряд несколько пустых дней, а затем день со слотами', () => {
    test('Тогда пустые дни схлопываются в диапазон одного месяца', () => {
      jest.useFakeTimers().setSystemTime(new Date('2026-03-10T12:00:00Z'))

      const items = getDateItemsFromSlots({
        '2026-03-04': [{ time: '16:00' }],
        '2026-03-05': [],
        '2026-03-06': [],
        '2026-03-07': [{ time: '10:00' }],
      }, ru)

      expect(items.map(item => ({
        date: item.date,
        disabled: item.disabled,
        title: item.title,
        subtitle: item.subtitle,
      }))).toEqual([
        {
          date: '2026-03-04',
          disabled: false,
          title: '4 мар',
          subtitle: 'Ср',
        },
        {
          date: '2026-03-05',
          disabled: true,
          title: '5–6 мар',
          subtitle: 'Чт–Пт',
        },
        {
          date: '2026-03-07',
          disabled: false,
          title: '7 мар',
          subtitle: 'Сб',
        },
      ])
    })
  })

  describe('Когда пустые дни пересекают границу месяца', () => {
    test('Тогда в диапазоне остаются обе даты целиком', () => {
      jest.useFakeTimers().setSystemTime(new Date('2026-03-10T12:00:00Z'))

      const items = getDateItemsFromSlots({
        '2026-02-27': [{ time: '16:00' }],
        '2026-02-28': [],
        '2026-03-01': [],
        '2026-03-02': [{ time: '10:00' }],
      }, ru)

      expect(items[1]).toMatchObject({
        date: '2026-02-28',
        disabled: true,
        title: '28 фев – 1 мар',
        subtitle: 'Сб–Вс',
      })
    })
  })

  describe('Когда дата совпадает с сегодняшним или завтрашним днём', () => {
    test('Тогда label «Сегодня» и «Завтра»', () => {
      jest.useFakeTimers().setSystemTime(new Date('2026-03-04T12:00:00Z'))

      const items = getDateItemsFromSlots({
        '2026-03-04': [{ time: '10:00' }],
        '2026-03-05': [{ time: '11:00' }],
      }, ru)

      expect(items.map(item => item.label)).toEqual(['Сегодня', 'Завтра'])
    })
  })
})
